module.exports = __webpack_public_path__ + "static/media/headphone.e3f2c527.svg";